import PropTypes from 'prop-types';

const concatenated = (name) => (name.length >= 10 ? name.slice(0, 10).concat('...') : name);

const Name = ({ name }) => {
  return concatenated(name);
};

Name.propTypes = {
  name: PropTypes.string.isRequired,
  clickable: PropTypes.bool,
};

export default Name;
